<template>
  <Head :title="__('balance.click-actions.title')" />

  <Breadcrumbs
    :pages="[
      { name: __('balance.overview.title'), href: route('frontend.balance') },
    ]"
    :current-page="__('balance.click-actions.title')"
  />

  <section class="container mb-6 md:mb-4">
    <h1 class="text-2xl md:text-3xl font-bold mb-4 md:mb-2.5">
      {{ __('balance.click-actions.title') }}
    </h1>
  </section>
  <section class="container mb-6">
    <div class="w-full bg-white mb-6 rounded-l shadow p-4 divide-solid divide-y">
      <div class="flex flex-wrap mt-2 mb-2 md:text-black text-xs md:text-sm font-bold w-full">
        <div class="w-4/12 md:w-8/12">
          {{ __('balance.description') }}
        </div>
        <div class="w-4/12 md:w-2/12 pl-3 text-right">
          {{ __('balance.date') }}
        </div>
        <div class="w-4/12 md:w-2/12 pl-3 text-right">
          {{ __('balance.qoins') }}
        </div>
      </div>
      <template v-if="clickActions.meta.pagination.total > 0">
        <div
          v-for="clickAction in clickActions.data"
          :key="clickAction.id"
          class="py-2"
        >
          <div class="flex w-full mb-1 text-sm md:text-base">
            <div class="w-4/12 md:w-8/12">
              {{ clickAction.name }}
            </div>
            <div class="w-4/12 md:w-2/12 pl-3 text-right">
              {{ clickAction.date }}
            </div>
            <div class="w-4/12 md:w-2/12 pl-3 text-right">
              {{ clickAction.value }}
            </div>
          </div>
        </div>
      </template>

      <p
        v-else
        class="text-sm md:text-base text-center py-2"
      >
        {{ __('balance.click-actions.no-data') }}
      </p>

      <div
        v-if="clickActions.meta.pagination.links.length > 3"
        class="pt-4"
      >
        <Pagination :pagination="clickActions.meta.pagination" />
      </div>
    </div>
  </section>
  <Faq :faq-items="faqItems" />
</template>

<script>
import Breadcrumbs from '../../Components/Breadcrumbs.vue';
import Pagination from '../../Components/Pagination.vue';
import Faq from './Components/Faq.vue';

export default {
  components: {
    Faq,
    Breadcrumbs,
    Pagination,
  },

  props: {
    clickActions: {
      type: Object,
      required: true,
    },

    faqItems: {
      type: Array,
      required: false,
      default: () => [],
    },
  },

};
</script>
